import { styled, FormControl } from "@material-ui/core";
import { brand } from "../../../theme";
import { FormLabel } from "../styles/shared";

export const ChangesMadeField = styled(({
    changesMade,
    ...p
}) =>
    <FormControl
        margin="normal"
        fullWidth
        {...p}
    >
        <FormLabel>Changes Made</FormLabel>
        <div className="card">
            <span className="label">Total edits to this round</span>
            <span className="count">{changesMade}</span>
        </div>
    </FormControl>
)(({ theme }) => ({
    marginTop: theme.spacing(3),
    "& .card": {
        background: brand.white,
        borderRadius: 12,
        padding: theme.spacing(1.5, 2),
        boxShadow: "0 1px 4px rgba(26,18,5,0.06)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(1),
    },
    "& .label": {
        fontSize: 13,
        color: brand.textSec,
    },
    "& .count": {
        fontSize: 22,
        fontWeight: 800,
        color: brand.text,
    },
}));
